export enum ItemDispatchProgress {
  PENDING = 'PENDING',
  IN_TRANSIT = 'IN_TRANSIT',
  COMPLETE = 'COMPLETE',
}

export enum DispatchProgress {
  PENDING = 'PENDING',
  PARTIAL = 'PARTIAL',
  IN_TRANSIT = 'IN_TRANSIT',
  COMPLETE = 'COMPLETE',
}

export enum DispatchDirection {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
}

export type DispatchStatusUpdateRequest = {
  orderId: number;
  products: { productId: number; to: ItemDispatchProgress; direction: string }[];
};
